var enLang = {
	"Tên sản phẩm đang được cập nhật": "Product name is updating",
	"Tặng ngay": "Receive",
	"Vui lòng chọn linh kiện": "Please select accessory",
	"Liên hệ": "Contact",
	"Chọn": "Select",
	"Bộ lọc": "Filter",
	"Sắp xếp theo": "Sort by",
	"Bán chạy": "Best selling",
	"Giá tăng dần": "Price ascend",
	"Giá giảm dần": "Price descend",
	"Tìm linh kiện": "Search accessory",
	"Thương hiệu": "Brand",
	"Khác": "Other",
	"Bàn phím số": "Numeric keyboard",
	"không phím số": "no number pad",
	"có phím số": "number pad",
	"Bộ nhớ laptop (filter)": "Laptop memory (filter)",
	"Chip đồ họa rời": "Discrete graphics chip",
	"Chuẩn độ phân giải": "Standard resolution",
	"Đầu đọc thẻ nhớ SD": "SD card reader",
	"Chi phí dự tính:": "Estimated amount:",
	"Thêm vào giỏ hàng": "Add to cart",
	"Cấu hình": "Configuration",
	"Tải cấu hình": "Download configuration",
	"Tạo lại": "Reset configuration",
	"Tổng chi phí:": "Total amount:",
	"Đã kết thúc": "Finished",
	"Xem chi tiết": "View detail",
	"với tất cả các nhà cung cấp": "with all suppliers",
	"với {{ApplySellerIdsLength}} nhà cung cấp": "with {{ApplySellerIdsLength}} suppliers",
	"Mã giảm giá/Phiếu mua hàng": "Discount code/e-voucher",
	"Nhập mã của bạn": "Input code",
	"Áp dụng ngay": "Apply now",
	"src.Cart.CartDiscount.CartDiscountSeller.0": "Some discount codes have special conditions, you need",
	"đăng nhập": "login",
	"để xem tất cả mã khuyến mại của bạn": "to view all applicable promotions",
	"src.Cart.CartDiscount.CartDiscountSeller.1": "Discount code/e-voucher is irrevertible after check-out",
	"Giảm giá toàn đơn": "Full discount",
	"Tặng 1 Ba lô Acer": "Receive 1 Acer backpack",
	"Tặng 1 bàn phím Logitech Tặng 1 bàn phím Logitech": "Receive Logitech keyboard",
	"Giỏ hàng chưa có sản phẩm nào": "Cart is empty",
	"Mua sắm ngay": "Shopping now",
	"Trường bắt buộc": "Required fields",
	"Email không đúng định dạng": "Email is invalid format",
	"Tên doanh nghiệp": "Company",
	"Nhập tên doanh nghiệp": "Input company name",
	"Mã số thuế": "Tax code",
	"Nhập mã số thuế": "Input tax code",
	"Email nhận hóa đơn": "Email",
	"Nhập email nhận hóa đơn": "Input email",
	"Địa chỉ trên hóa đơn": "Address",
	"Nhập địa chỉ trên hóa đơn": "Input address",
	"Thông tin người đặt hàng": "Customer information",
	"Họ tên": "Name",
	"Nhập họ tên": "Input name",
	"Số điện thoại": "Phone number",
	"Nhập số điện thoại": "Input phone number",
	"Nhập email": "Input email",
	"Địa chỉ nhận hàng": "Address",
	"Tỉnh/Thành phố": "Province",
	"Quận huyện": "District",
	"Phường xã": "Ward",
	"Địa chỉ": "Address",
	"Nhập địa chỉ": "Input address",
	"Sử dụng làm thông tin người mua hàng": "Use as delivery information",
	"Thông tin người mua hàng": "Delivery information",
	"Lưu địa chỉ": "Save",
	"Sắp cháy hàng": "Out of stock soon",
	"Còn lại {{remain}}": "Remain {{remain}}",
	"Còn lại ": "Remain ",
	"(Đã bao gồm VAT{{var0}})": "(VAT included {{var0}})",
	"(Đã bao gồm phí giao hàng)": "(shipping fee included)",
	"Tổng tạm tính": "Grand total",
	"Tổng nâng giá": "Total price",
	"Phí vận chuyển": "Shipping fee",
	"Giảm giá": "Discount",
	"Thành tiền": "Total amount",
	"Không tìm thấy sản phẩm nào": "No product found",
	"Đã gửi mã OTP": "OTP sent",
	"Đã gửi lại mã OTP": "OTP re-sent",
	"Tiếp tục với số điện thoại": "Continue with phone number",
	"src.Common.PhoneLogin.PhoneLogin.0": "Login or Registration with your phone number",
	"Gửi": "Send",
	"Vui lòng nhập số OTP đã được gửi về số điện thoại {{phone}} để thực hiện đăng nhập": "Please input OTP sent to your phone number {{phone}} to login",
	"Gửi lại mã": "Re-send",
	"Gửi lại mã sau {{countDownTime}}s": "Re-send after {{countDownTime}}s",
	"QUÀ TẶNG": "GIFT",
	"LIÊN HỆ": "CONTACT",
	"Hết hàng": "Out of stock",
	"Thêm vào giỏ": "Add to cart",
	"Chỉ giao hàng tại HN & HCM": "Delivery within HN & HCM only",
	"Trả góp 0%": "Installment 0%",
	"Hàng đặt trước": "Pre-order",
	"Nhập mã": "Input code",
	"Giảm ngay": "Discount",
	"Chỉ còn": "Only",
	"sản phẩm": "product",
	"Nhận xét và đánh giá": "Feedback and review",
	"Trung bình của:": "Average of:",
	"nhận xét": "review",
	"Chưa có đánh giá nào": "No rating",
	"Nhận xét của bạn": "Your review",
	"1. Đánh giá về sản phẩm:": "1. Product rating:",
	"2. Viết nhận xét:": "2. Review:",
	"Nhận xét về sản phẩm": "Review about product",
	"Gửi nhận xét": "Submit review",
	"Bỏ chọn": "Un-select",
	"Áp dụng": "Apply",
	"Mua thêm": "Buy more",
	"Từ khóa phổ biến": "Popular keyword",
	"Lịch sử tìm kiếm": "Search history",
	"Nhập lý do": "Reason",
	"cho đơn hàng": "for the order",
	"cho đơn hàng tối thiểu": "for the order min",
	"cho đơn hàng tối đa": "for the order max",
	"cho đơn hàng từ": "for the order from",
	"đến": "to",
	"Giảm thêm": "Discount",
	"% tối đa": "% max",
	"có chứa sản phẩm hiện tại": "include the current product",
	"điều kiện sử dụng và chính sách": "terms of use and policy",
	"Tài khoản của": "Account of",
	"Danh sách các ngân hàng thanh toán online": "List of online payment banks",
	"Hỗ trợ khách hàng": "Customer support",
	"Thẻ ưu đãi": "Preferential card",
	"Phiếu mua hàng": "e-voucher",
	"Trung tâm bảo hành": "Service Center",
	"Thanh toán và giao hàng": "Payment and delivery",
	"Dịch vụ sửa chữa và bảo trì": "Repair and maintenance service",
	"Chính sách Mua hàng và Bảo hành": "Purchase and Warranty Policy",
	"Quy định chung": "General rules",
	"Chính sách Bảo mật Thông tin": "Information Privacy Policy",
	"Chính sách Vận chuyển, Giao nhận": "Shipping and Delivery Policy",
	"Chính sách bảo hành": "Warranty Policy",
	"Chính sách mặt hàng Điện máy": "Policy on electrical goods",
	"Chính sách đổi trả và hoàn tiền": "Return and Refund Policy",
	"Quy định giá cả và hình thức thanh toán": "Regulation of prices and forms of payment",
	"Chính sách trả góp": "Installment Policy",
	"Thông tin Phong Vũ": "Phong Vũ information",
	"Thông tin liên hệ": "Contact Info",
	"Hệ thống Showroom": "Showrooms",
	"Giới thiệu Phong Vũ": "Phong Vũ introduction",
	"Hỏi đáp": "Q&A",
	"Tin công nghệ": "Tech news",
	"Tuyển dụng": "Career",
	"Cộng đồng Phong Vũ": "Phong Vũ community",
	"Phong Vũ Hội": "Phong Vũ Community",
	"Gọi Mua hàng: 1800 6867 (miễn phí)": "Call to buy: 1800 6867 (free)",
	"Gọi Chăm sóc: 1800 6865 (miễn phí)": "Call for support: 1800 6865 (free)",
	"Tổng đài (cũ): 1900 1835 (1000đ/phút)": "Hotline (old): 1900 1835 (1000đ/minute)",
	"Email liên hệ": "Email support",
	"Hỗ trợ Khách hàng:": "Customer support:",
	"Liên hệ báo giá:": "Contact for quotation:",
	"Hợp tác phát triển:": "Collaboration:",
	"Phương thức thanh toán": "Payment method",
	"Tiền mặt": "Cash",
	"Trả góp": "Installment",
	"Công ty cổ phần thương mại dịch vụ Phong Vũ": "Phong Vũ trading joint stock company",
	"Xóa bộ lọc": "Reset filter",
	"Bộ lọc nâng cao": "Advance filter",
	"Khuyến mãi tốt nhất": "Best promotion",
	"Mới về": "Latest",
	"Giá thấp nhất": "Lowest price",
	"Giá cao nhất": "Highest price",
	"Tìm": "Search",
	"Sản phẩm": "Product",
	"Giá trị": "Value",
	"Số lượng": "Quantity",
	"Tổng tiền": "Total amount",
	"Trả lại": "Return",
	"Cung cấp bởi": "Provided by",
	"{{quantity}}x Giảm giá {{var0}}": "{{quantity}}x Discount {{var0}}",
	"{{VoucherQuantity}}x Voucher giảm giá cho đơn hàng sau": "{{VoucherQuantity}}x Voucher for the next order",
	"KHUYẾN MÃI CHO ĐƠN HÀNG": "ORDER PROMOTIONS",
	"Vận đơn {{index}}{{var0}}": "Shipment {{index}}{{var0}}",
	"Xem chi tiết vận đơn": "View shipment detail",
	"Cần thanh toán:": "Remain payment:",
	"Khuyến mãi cho đơn hàng": "Order promotion",
	"Tạm tính": "Grand total",
	"Tặng phiếu mua hàng điện máy Phong Vũ": "Receive e-voucher for eletrics at Phong Vũ",
	"Đặt hàng thành công": "Place order successfully",
	"Đóng gói xong": "Packed",
	"Đang lấy hàng": "Picking",
	"Đang vận chuyển": "Delivering",
	"Giao hàng thành công": "Delivered",
	"Mã đơn hàng": "Order code",
	"Ngày mua": "Created date",
	"Tổng tiền (đ)": "Total amount (đ)",
	"Trạng thái": "Status",
	"Card màn hình GIGABYTE GeForce GTX 1660Ti 6GB GDDR6 OC(GV-N166TOC-6GD)": "Graphic card GIGABYTE GeForce GTX 1660Ti 6GB GDDR6 OC(GV-N166TOC-6GD)",
	"Máy lọc không khí Daikin MC70MVM6": "Air purifier Daikin MC70MVM6",
	"THÊM VÀO GIỎ HÀNG": "ADD TO CART",
	"HẾT HÀNG": "OUT OF STOCK",
	"Cam kết hàng chính hãng 100%": "100% genuine guarantee",
	"Miễn phí giao hàng từ 500K": "Free delivery from 500K",
	"Đổi trả miễn phí trong 10 ngày": "ĐFree returns in 10 days",
	"Sửa chữa đồng giá 150.000đ.": "Repair with the same price 150,000 VND.",
	"Bảo hành tại nhà.": "Home Warranty.",
	"Điện thoại SAMSUNG Galaxy Note 10+ 12GB/256GB (Bạc)": "SAMSUNG Galaxy Note 10+ 12GB/256GB (Silver)",
	"Hệ điều hành": "Operation system",
	"Thông tin chung": "General information",
	"Bảo hành": "Warranty",
	"24 tháng": "24 months",
	"Mô tả bảo hành": "Warranty Description",
	"Màu sắc": "Color",
	"Bạc": "Silver",
	"Cấu hình chi tiết": "Detailed configuration",
	"src.ProductDetail.mocks.0": "15.6\" ( 1366 x 768 ) HD non-touch, VGA webcam",
	"Cổng kết nối": "Connector",
	"Số cổng lưu trữ tối đa": "Max number of storage ports",
	"Siêu robot hút bụi": "Super robot vacuum cleaner",
	"Tiết kiệm hơn khi mua cùng {{name}}": "Save more when buying together {{name}}",
	"Tiết kiệm:": "Save:",
	"Giảm trực tiếp": "Discount",
	"Tặng": "Receive",
	"Đã áp dụng mã giảm giá": "Discount code applied",
	"giảm": "discount",
	"Xem thêm": "Expand",
	"Thu gọn": "Collapse",
	"Thông số kỹ thuật": "Specification",
	"Giá:": "Price:",
	"Đã giảm thêm": "Discount more",
	"Đã áp dụng": "Applied",
	"Chờ thanh toán": "Waiting for payment",
	"Chờ giao hàng": "Waiting for delivery",
	"Đã hoàn thành": "Completed",
	"{{hours}} giờ": "{{hours}} hour",
	"{{PrimaryName}} và {{var0}} sản phẩm khác": "{{PrimaryName}} and {{var0}} other products",
	"Mặc định": "Default",
	"Xem tất cả": "View all",
	"sản phẩm tặng ngay": "received product",
	"Voucher dùng cho đơn hàng sau": "Voucher for the next order",
	"Mã giảm giá": "Discount code",
	"Bấm để chọn": "Tap to select",
	"Tối đa": "Max",
	"Tất cả": "All",
	"{{ApplySellerIdsLength}} nhà cung cấp": "{{ApplySellerIdsLength}} suppliers",
	"Đơn hàng từ": "Order from",
	"Đơn hàng tối thiểu": "Order from",
	"Đơn hàng dưới": "Order under",
	"Tất cả các đơn hàng": "All orders",
	"(Chỉ áp dụng trên một số sản phẩm nhất định)": "(Applicable for some specific products only)",
	"VNSHOP - mã cho đơn 86WD": "VNSHOP - code for order 86WD",
	"Miễn phí giao hàng cho đơn hàng từ 300K": "Free delivery for the order from 300K",
	"Giảm thêm 10%, tối đa 50k, khi thanh toán VNPAY-QR": "Discount more 10%, max 50k, pay via VNPAY-QR",
	"Đổi trả trong vòng 10 ngày": "Free exchange in 10 days",
	"Mua máy tính - đến Phong Vũ": "Buy a computer - come to Phong Vũ",
	"Hoàn tiền 150% nếu hàng không chính hãng": "150% refund if the item is not genuine",
	"Mua sắm đơn giản hơn": "Shopping more simple",
	"Hàng tiêu dùng Nhật Bản - Thời trang thông minh": "Japanese consumer goods - Smart fashion",
	"Giao hàng nhanh 4h trong nội thành (đặt trước 18:00)": "Fast delivery 4 hours in the inner city (order before 18:00)",
	"An tâm mua sắm mỗi ngày": "Shop with peace of mind every day",
	"Mỹ phẩm chính hãng Hàn Quốc": "Genuine Korean cosmetics",
	"Làn da không tuổi": "Ageless skin",
	"Trung thành với các giá trị cốt lõi": "Loyalty to core values",
	"src.mobile.Cart.CouponSelector.CouponSelector.data.3": "Due to the impact of COVID, Vnshop temporarily suspends delivery activities in Da Nang",
	"Nhà phân phối chính thức của HEAD tennis": "Official distributor of HEAD tennis",
	"Bí quyết cho làn da tươi trẻ": "The secret to youthful skin",
	"Mang đến thiên nhiên cho làn da của bạn": "Bring nature to your skin",
	"Thiên đường mỹ phẩm Hàn Quốc": "Korean cosmetic paradise",
	"Thương hiệu gia dụng cao cấp Châu Âu": "European luxury household brand",
	"Mỹ phẩm chính hãng từ Canada": "Genuine cosmetics from Canada",
	"Mỹ phẩm chính hãng từ Thái Lan": "Genuine cosmetics from Thailand",
	"Thức uống lên men dành cho sức khỏe": "Fermented drink for health",
	"TTC Sugar Chính hãng": "TTC Sugar official",
	"Phát triển bền vững cùng cây mía Việt Nam": "Sustainable development with Vietnamese sugarcane",
	"Thương hiệu siêu thị cao cấp Nhật Bản": "High-end Japanese supermarket brand",
	"Sản phẩm dinh dưỡng nhập khẩu 100% từ Úc": "Nutrition products imported 100% from Australia",
	"Công ty 266": "266 company",
	"Mỹ phẩm trang điểm hữu cơ từ Nhật Bản": "Organic makeup cosmetics from Japan",
	"Mỹ phẩm thiên nhiên thuần khiết": "Pure natural cosmetics",
	"Vì một thế hệ thông minh": "For a smart generation",
	"Sản Phẩm Chính Hãng Từ Pháp": "Genuine Products From France",
	"CÔNG TY CỔ PHẦN VENUS INC VIỆT NAM": "VENUS INC JOINT STOCK COMPANY VIETNAM",
	"Khơi nguồn cảm hứng cho sắc đẹp": "Inspiration for beauty",
	"ÁP DỤNG NGAY 1 MÃ GIẢM GIÁ": "APPLY 1 DISCOUNT CODE NOW",
	"MUA THÊM ĐỂ ÁP DỤNG MÃ": "BUY MORE TO GET DISCOUNT",
	"Nhập mã giảm giá để hưởng ưu đãi": "Enter the discount code to enjoy the offer",
	"Nhập mã giảm giá": "Input discount code",
	"Áp Dụng": "Apply",
	"Không có sản phẩm nào trong giỏ hàng": "No product in the cart",
	"Quà tặng từ {{name}}": "Gift from {{name}}",
	"Đã chọn": "Selected",
	"Nhập thời gian nhận hàng": "Input delivery time",
	"Chưa có đơn hàng nào.": "No order found.",
	"Không tìm thấy dữ liệu": "No data found",
	"Không hỗ trợ file với phần mở rộng này.": "Not support this file extension.",
	"Kích thước file quá lớn": "File size too large",
	"Tổng dung lượng các file quá lớn": "Total file size too large",
	"Quá số lượng file cho phép": "Exceed number of allowed file",
	"Thêm hình ảnh": "Add image",
	"Sắp xếp": "Sort",
	"Kêu gọi mua chung": "Group buy",
	"Còn {{days}} ngày": "Remain {{days}} days",
	"Đơn hàng": "Order",
	"Người": "People",
	"Còn": "Remain",
	"Mã đơn": "Order code",
	"Thanh toán ngay": "Pay now",
	"Giảm giá {{discount}}": "Discount {{discount}}",
	"Quà tặng cho đơn hàng": "Order gift",
	"Chuột chơi game xịn": "Good gaming mouse",
	"Pad chuột": "TouchPad",
	"Chuột chơi game đểu": "Crazy gaming mouse",
	"Qùa tặng cho đơn hàng": "Order gift",
	"Giảm {{PromotionValue}}": "Discount {{PromotionValue}}",
	"src.mobile.ProductCard.ProductCard.0": "This is alcohol included product, please confirm that you are 18 years old to buy this product!",
	"Cảnh báo": "Warning",
	"Tôi dưới 18 tuổi": "I am under 18",
	"Tôi trên 18 tuổi": "I am over 18",
	"Tạm hết hàng": "Out of stock",
	"Mô tả sản phẩm": "Description",
	"src.mobile.ProductDetail.ProductShortDescriptionMobile.0": "Description will be updated soon!",
	"Còn lại:": "Remain:",
	"Giờ vàng giá sốc": "Flash sale",
	"Tặng voucher": "Receive voucher",
	"Mã": "Code",
	"{{BenefitPercent}}% tối đa {{var0}}": "{{BenefitPercent}}% max {{var0}}",
	"Bạn sẽ nhận được": "You will receive",
	"Tiết kiệm": "Save",
	"Giảm {{var0}} {{var1}}": "Discount {{var0}} {{var1}}",
	"Chọn thêm 1 trong những khuyến mại sau": "Select 1 of the following promotions",
	"Chi tiết khuyến mãi": "Detailed promotions",
	"Tên chương trình": "Campaign name",
	"Hạn sử dụng": "Expiry date",
	"Đến": "To",
	"Quà khuyến mãi": "Gift",
	"Thương hiệu hàng đầu": "Popular brand",
	"giờ": "hour",
	"ngày": "day",
	"Chỉ còn {{totalAvailableByStocks}} sản phẩm": "Remain {{totalAvailableByStocks}} products",
	"Mua ngay": "Buy now",
	"Mã/phiếu mua hàng": "Coupons/E-vouchers"
};

export { enLang as default };
